import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { ProductList } from './product-list';
import { ToastContainer } from 'react-toastify';

export function initProductList() {
  document.getElementsByName('product-list').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductList />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
